import React from 'react';
import 'styles/admin/DepartmentProfileList.styl';
import 'styles/admin/CardReasonList.styl';

export default class CardReasonList extends React.PureComponent {
  render() {
    const reasons = this.props.reasons;

    if (reasons.size === 0) {
      return (
        <div className="card-reason-profiles-list">
          You don't have any scoring reasons defined yet.
        </div>
      );
    }
    return (
      <table className="card-reason-profiles-list">
        <tbody>
          <tr>
            <th>Name</th>
            <th># Scorecards with scheme</th>
          </tr>
          {reasons.map(reason => (
            <tr key={'reason_row_' + reason.id}>
              <td className="name" onClick={() => this.props.openCardReasonEditForm(reason.id)}>
                {reason.name}
              </td>
              <td className="cards_number">{reason.cardsNumber}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }
}
